import { Injectable } from '@angular/core';
import { Router, NavigationExtras } from '@angular/router';
import { Location } from '@angular/common';
import {scrollUp} from '../functions/scroll-up';

@Injectable({
  providedIn: 'root'
})
export class NavigationService {
  constructor(
    private router: Router,
    private location: Location
  ) {}

  backOrHome(): void {
    if (window.history.length > 1) {
      this.location.back();
    } else {
      scrollUp();
      this.router.navigate(['/']).then();
    }
  }

  backOrRoute(fallbackRoute: any[] = ['/'], extras?: NavigationExtras): void {
    if (window.history.length > 1) {
      this.location.back();
    } else {
      scrollUp();
      this.router.navigate(fallbackRoute, extras).then();
    }
  }

  redirectToLoginWithReturnUrl(): void {
    const currentUrl = this.router.url;
    scrollUp();
    this.router.navigate(['/login'], {
      queryParams: { returnUrl: currentUrl }
    }).then();
  }
}
